import React, { createContext, useState, useContext } from "react";

const DragContext = createContext({
    isDragging: false,
    startDrag: () => { },
    endDrag: () => { },
});

export const useDragContext = () => useContext(DragContext);

export const DragProvider = ({ children }) => {
    const [isDragging, setIsDragging] = useState(false);

    const startDrag = (e, item) => {
        if (e?.dataTransfer) {
            e.dataTransfer.setData("symbolId", item?.id);
            e.dataTransfer.effectAllowed = "move";
        } else {
            console.warn("Drag event has no dataTransfer");
        }
        setTimeout(() => {
            setIsDragging(true);
        }, 0);
    }
    const endDrag = () => setTimeout(() => {
        console.log("endDrag");
        setIsDragging(false);
    }, 0);

    return (
        <DragContext.Provider value={{ isDragging, startDrag, endDrag }}>
            {children}
        </DragContext.Provider>
    );
};
